import { render, staticRenderFns } from "./VaultRectangle.vue?vue&type=template&id=2d34c4d4"
import script from "./VaultRectangle.vue?vue&type=script&lang=js"
export * from "./VaultRectangle.vue?vue&type=script&lang=js"
import style0 from "./VaultRectangle.vue?vue&type=style&index=0&id=2d34c4d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports